import React, { useState } from "react";
import styles from "styles/component/SideBar.module.scss";
import { Button } from "@mui/material";
import asset from "json/assets";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  driving_range_gps_create,
  driving_range_gps_update,
} from "redux/MapSlice";
import {
  useAddedShapedStatus,
  useDrivingRangeGPSDetailsStatus,
  useEditableArea,
  useIsNewShapeFlag,
  useViewShapeData,
} from "hooks/MapDetails";
import { logger } from "services/logger";
import {
  checkPayloadDataAvailable,
  convertToLabelName,
  dataCheck,
  decryptSecretKey,
  getBoundsAndElementWisePoints,
  getModalProperties,
  isIdCode12,
} from "services/utils";
import useNotiStack from "hooks/useNotistack";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import { booleanPointInPolygon } from "@turf/turf";
import { mandatoryShapes } from "json/constants";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import {
  useCourseGPSMappingData,
  useCourseMapData,
  useEditableCourseItem,
  useIsDrawingStatus,
  useTransformedCourseData,
  useTransformedHoleData,
} from "hooks/CourseMapDetails";
import * as _ from "underscore";
import {
  course_sync_output_create,
  vector_output_create,
  course_mapping_note_create,
  course_mapping_note_list,
} from "redux/CourseMapSlice";
import { clearSearchedCourseName } from "redux/CourseSlice";
import { useAssociatedCourseData } from "hooks/RangeDetails";
export default function SideBar(props) {
  const modalProperties = getModalProperties();
  const dispatch = useDispatch();
  const isNewShape = useIsNewShapeFlag();
  const secretKey = decryptSecretKey();
  const [searchParams] = useSearchParams();
  const editableArea = useEditableArea();
  const addedShapeStatus = useAddedShapedStatus();

  const transformedCourseData = useTransformedCourseData();
  const transformedHoleData = useTransformedHoleData();
  const editableCourseMapItem = useEditableCourseItem();
  const isCourseMapDrawing = useIsDrawingStatus();
  const id_drivingRangeFromQuery = searchParams.get("range");
  const id_courseFromQuery = searchParams.get("course");
  const { toastSuccess, toastError } = useNotiStack();

  const profileData = JSON.parse(localStorage.getItem("profile_data"));
  const mapGenGPSStatus = useDrivingRangeGPSDetailsStatus();
  const [open, setOpen] = useState(false);
  const [openConfModal, setOpenConfModal] = useState(false);
  const [openBackToListModal, setOpenBackToListModal] = useState(false);
  const associatedCourseData = useAssociatedCourseData();
  const payloadShapeData = useViewShapeData();

  const courseMapData = useCourseMapData();
  const courseGPSMapping = useCourseGPSMappingData();
  const courseGPSMappingData = courseGPSMapping?.GPSList;
  const navigate = useNavigate();
  const toggleOpen = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpenConfModal(false);
  };
  props.handleCallBack(open);
  const currentRoute = window.location.pathname;
  const redirectToList = () => {
    switch (currentRoute) {
      case "/mapview/drivingrange":
        navigate("/drivingrange");
        break;
      case "/mapview/heatmap":
        navigate("/heatmap");
        break;
      case "/mapview/coursemap":
        redirectToCourseMap();
        break;
      default:
        navigate("/drivingrange");
    }

    // if (currentRoute === "/mapview/heatmap") {
    //   navigate("/heatmap");
    // } else {
    //   navigate("/drivingrange");
    // }
  };

  const handleBacktoListModal = () => {
    setOpenBackToListModal(false);
  };

  const checkDrawingStatus = (type) => {
    if (
      !_.isEmpty(editableCourseMapItem) ||
      editableArea ||
      addedShapeStatus === "drawing" ||
      isCourseMapDrawing
    ) {
      type === "save" ? setOpenConfModal(true) : setOpenBackToListModal(true);
      return;
    } else {
      type === "save" ? saveData() : redirectToList();
    }
  };

  const saveDrivingRangeData = () => {
    //checking if mandatory shapes are added
    let isError = mandatoryShapes?.some((item) => {
      if (
        payloadShapeData?.shapes?.hasOwnProperty(item) &&
        payloadShapeData?.shapes?.[`${item}`]?.length === 0
      ) {
        toastError(`Can not save without ${convertToLabelName(item)}`);
        return true;
      }
      return false;
    });

    if (isError) {
      return;
    }
    if (
      payloadShapeData?.shapes?.hasOwnProperty("perimeter") &&
      payloadShapeData?.shapes?.perimeter?.length !== 0
    ) {
      let isInsideAllowedPolygon = [];

      const { elementWiseList } = getBoundsAndElementWisePoints(
        payloadShapeData.shapes
      );
      const allowedPolygon = elementWiseList?.find(
        (s) => s.label === "PM1"
      )?.list;

      elementWiseList?.forEach((item, index) => {
        if (item?.label !== "PM1") {
          let _e = [...item.list].flat();
          _e?.forEach((pItem) => {
            isInsideAllowedPolygon.push(
              booleanPointInPolygon(pItem, {
                type: "Polygon",
                coordinates: allowedPolygon,
              })
            );
          });
        }
      });
      if (isInsideAllowedPolygon.includes(false)) {
        toastError("Some shapes are outside the perimeter!");
        return;
      }
    }

    if (
      mapGenGPSStatus === "idle" &&
      checkPayloadDataAvailable(payloadShapeData?.shapes)
    ) {
      let payload = {
        info: { id_drivingRange: id_drivingRangeFromQuery },
        shapes: payloadShapeData?.shapes,
      };

      if (isNewShape) {
        // for save ..
        dispatch(
          driving_range_gps_create({
            body: { ...payload },
            user: { secretKey: secretKey, userName: profileData.username },
          }) // Currently works for Kholod_TEST range only
        )
          ?.then((success) => {
            if (success?.payload?.data?.Status === 1) {
              toastSuccess(success?.payload?.data?.ErrorMessage);
              redirectToList();
            } else {
              logger(
                " driving_range_gps_create error: ",
                success?.payload?.data?.ErrorMessage
              );
              toastError("Something went Wrong!");
            }
          })
          ?.catch((error) => {
            console.error("error", error);
            toastError("Something went Wrong!");
          });
      } else {
        // for edit
        logger("EDIT API WILL BE CALLED");

        dispatch(
          driving_range_gps_update({
            body: { ...payload },
            user: { secretKey: secretKey, userName: profileData.username },
          }) // Currently works for Kholod_TEST range only
        )
          ?.then((success) => {
            if (success?.payload?.data?.Status === 1) {
              toastSuccess(success?.payload?.data?.ErrorMessage);
              redirectToList();
            } else {
              // toastError(success?.payload?.data?.ErrorMessage);
              logger(
                " driving_range_gps_update error: ",
                success?.payload?.data?.ErrorMessage
              );
              toastError("Something went Wrong!");
            }
          })
          ?.catch((error) => {
            console.error("error", error);
            toastError("Something went Wrong!");
          });
      }
    }
  };

  const logSaveAttemptNote = (thunkName, errorMessage) => {
    const note = `${thunkName}: "${errorMessage ?? ""}"`;
    dispatch(
      course_mapping_note_create({
        body: {
          note,
          id_course: Number(id_courseFromQuery),
        },
        user: { secretKey: secretKey, userName: profileData.username },
      })
    )?.then(() => {
      dispatch(
        course_mapping_note_list({
          body: { id_course: id_courseFromQuery },
          user: { secretKey: secretKey, userName: profileData.username },
        })
      );
    });
  };

  const isThunkResponseSuccessful = (response) => {
    const httpStatus = response?.payload?.status;
    const bodyStatus = response?.payload?.data?.Status;
    const httpOk = typeof httpStatus === "number" && httpStatus >= 200 && httpStatus < 300;
    return httpOk && bodyStatus === 1;
  };

  const saveCourseMapData = async () => {
    dataCheck(courseMapData, courseGPSMapping,transformedHoleData,transformedCourseData)
      .then((result) => {
        if (result?.success) {
          dispatch(
            course_sync_output_create({
              body: {
                id_course: Number(id_courseFromQuery),
              },
              user: { secretKey: secretKey, userName: profileData.username },
            })
          )
            .then((res) => {
              if (isThunkResponseSuccessful(res)) {
                dispatch(
                  vector_output_create({
                    body: {
                      id_course: Number(id_courseFromQuery),
                    },
                    user: { secretKey: secretKey, userName: profileData.username },
                  })
                )
                  .then((response) => {
                    const serverMessage =
                      response?.payload?.data?.response?.message ??
                      response?.payload?.data?.ErrorMessage;

                    logSaveAttemptNote("VectorOutputCreate", serverMessage);

                    if (isThunkResponseSuccessful(response)) {
                      toastSuccess("Course Map Data saved Successfully");
                      redirectToList();
                    } else {
                      toastError(
                        `Vector Create failed (id_course: ${id_courseFromQuery}). HTTP ${response?.payload?.status ?? "?"} | Server response: ${serverMessage ?? JSON.stringify(response?.payload?.data)}`,
                      );
                    }
                  })
                  .catch((err) => {
                    logSaveAttemptNote("VectorOutputCreate", "Request failed");
                    console.error("Vector Create err: ", err);
                    toastError(`Vector Create error (id_course: ${id_courseFromQuery}): ${err?.message || err}`);
                  });
              } else {
                const serverMessage =
                  res?.payload?.data?.response?.message ??
                  res?.payload?.data?.ErrorMessage;

                logSaveAttemptNote("CourseSyncOutputCreate", serverMessage);
                toastError(`Course Sync failed (id_course: ${id_courseFromQuery}). HTTP ${res?.payload?.status ?? "?"} | Server response: ${serverMessage ?? JSON.stringify(res?.payload?.data)}`);
              }
            })
            .catch((err) => {
              logSaveAttemptNote("CourseSyncOutputCreate", "Request failed");
              console.error("error: ", err);
              toastError("Something went Wrong!");
            });
        }
      })
      .catch((err) => {
        toastError(err?.errMsg);
      });
  };

  const saveData = () => {
    //API call
    if (currentRoute === "/mapview/rangemap") {
      saveDrivingRangeData();
    } else if (currentRoute === "/mapview/coursemap") {
      saveCourseMapData();
    } else {
      eventEmitter.emit(events.uploadElevationData);
    }
  };

  const redirectToCourseMap = () => {
    if(isIdCode12(associatedCourseData.searchedCourseName)) {
      dispatch(clearSearchedCourseName());
    }

    navigate('/coursemap')
  }

  return (
    <>
      <div
        className={
          open
            ? `${styles.sidebar_list}`
            : `${styles.sidebar_list} ${styles.sidebar_list_open}`
        }
      >
        <ul>
          <li>
            {/* <Button onClick={redirectToList}> */}
            <Button onClick={() => checkDrawingStatus("list")}>
              <span className={styles.icon}>
                <img src={asset.listIconL} alt="" />
              </span>
              {/* <span style={open ? {width: "100%",opacity :"1"} : {width : "0",opacity:"0"}}>Course Map</span> */}
              <span
                className={
                  open ? `${styles.expand_span}` : `${styles.shrink_span}`
                }
              >
                Back To list
              </span>
            </Button>
          </li>
          <li>
            <Button onClick={() => checkDrawingStatus("save")}>
              <span className={styles.icon}>
                <img src={asset.saveIcon} alt="" />
              </span>
              <span
                className={
                  open ? `${styles.expand_span}` : `${styles.shrink_span}`
                }
              >
                Save
              </span>
              {/* <span style={open ? {width: "100%",opacity :"1"} : {width : "0",opacity:"0"}}>Assets</span> */}
            </Button>
          </li>
        </ul>
        <Button className={styles.open_drawer} onClick={toggleOpen}>
          <img src={asset.right_arrow} alt="" />
        </Button>
      </div>
      <ModalWrapper
        open={openConfModal}
        onClose={handleClose}
        handleClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.warning.backgroundColor}
          image={modalProperties.warning.icon}
          title="<b> You have unsaved data.</b>"
          content="Any unsaved data will be discarded."
          rejCallBack={handleClose}
          affrCallBack={() => {
            handleClose();
            saveData();
          }}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>
      <ModalWrapper
        open={openBackToListModal}
        onClose={handleBacktoListModal}
        handleClose={handleBacktoListModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.warning.backgroundColor}
          image={modalProperties.warning.icon}
          title="<b> You have unsaved data.</b>"
          content="Any unsaved data will be discarded."
          rejCallBack={handleBacktoListModal}
          affrCallBack={() => {
            handleBacktoListModal();
            redirectToList();
          }}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>
    </>
  );
}
